// extracted by mini-css-extract-plugin
export default {"wrapper":"SiteHomeBanner_wrapper","title":"SiteHomeBanner_title","button":"SiteHomeBanner_button","holder":"SiteHomeBanner_holder","image":"SiteHomeBanner_image"};